// Copyright (c) 2020 Deere & Company

export const filterLaborSubtypes = (allowedSubTypeKeys, allSubtypes) =>
    allSubtypes.filter(subtype => allowedSubTypeKeys.includes(subtype.key));



// WEBPACK FOOTER //
// ./src/claim/shared/services/filter-labor-subtypes.js